import { Component } from '@angular/core';
import { FullSpinnerService } from '../../services/full-spinner.service';
import { CommonModule } from '@angular/common';
import { Menu } from '../../models/LoggedUserInfo';
import { StorageService } from '../../services/storage.service';
import { SessionMonitorService } from '../../security/session-monitor.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  menu!: Menu[];
  constructor(
    private fullSpinnerService: FullSpinnerService,
    private storageService: StorageService,
    private sessionMonitor: SessionMonitorService,
    private router: Router
  ) {
    fullSpinnerService.spinner(undefined);
    this.sessionMonitor
      .sessionMonitor()
      .pipe()
      .subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          this.menu = this.storageService.getLoggedUser().menu;
        }
      });
  }

  ngOnInit(): void {
    if (this.storageService.getLoggedUser())
      this.menu = this.storageService.getLoggedUser().menu;

  }
  openMenu(menu_item: Menu) {
    this.fullSpinnerService.spinner('');
    this.storageService.setValue('current_selected_menu', menu_item);
    this.router.navigate([menu_item.page]);

  }

}
